import { useEffect, useState } from "react";
import { apiGet } from "../api/client";

interface Topic {
  id: string;
  name: string;
  parent_id: string | null;
}

export default function TopicNavigator() {
  const [topics, setTopics] = useState<Topic[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet<Topic[]>("/topics").then((r) => {
      setTopics(r);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <div className="mt-4 h-24 animate-pulse rounded border border-border" />;
  }

  const tree = (items: Topic[], depth = 0) =>
    items
      .filter((t) => t.parent_id === null || topics.some((p: Topic) => p.id === t.parent_id && p.parent_id === null))
      .map((t) => (
        <div key={t.id} className="ml-4" style={{ paddingLeft: depth * 14 }}>
          <div className="flex items-center gap-2 rounded border border-border px-3 py-2 text-sm">
            <span className="h-2 w-2 rounded-full bg-primary-500" />
            <span className="text-text">{t.name}</span>
          </div>
          {tree(topics.filter((c: Topic) => c.parent_id === t.id), depth + 1)}
        </div>
      ));

  return (
    <div>
      <h2 className="text-2xl font-bold text-text">Topik</h2>
      <p className="text-sm text-muted mt-1">Navigasi by topic · tag + scope</p>
      <div className="mt-4 space-y-4">{tree(topics)}</div>
    </div>
  );
}
